var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gigLoader"},[_c('content-placeholders',[_c('content-placeholders-img'),_vm._v(" "),_c('content-placeholders-heading',{attrs:{"img":true}}),_vm._v(" "),_c('content-placeholders-text',{attrs:{"lines":3}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64897da0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/gigLoading.vue
// module id = null
// module chunks = 